import React from 'react';

import { ErrorCard } from '@eika/card';
import { IconTypes } from '@eika/icon';
import { ListPanelWrapper } from '@eika/link-panel';
import { Loader } from '@eika/loader';

import piwik from '@/piwik/piwik';

import { useCreditCardAccount } from '@domain/account';
import { CreditCardPanelItem, useCreditCardDetails } from '@domain/card';
import useText from '@hooks/use-text';

const BlockReorderKb = () => {
    const cardQuery = useCreditCardDetails({ refetchOnMount: 'always', refetchOnWindowFocus: 'always' });
    const accountQuery = useCreditCardAccount({ refetchOnMount: 'always', refetchOnWindowFocus: 'always' });
    const { blockCard, unblockCard, reorderTitle, messageErrorText, blockTitle } = useText();

    if (
        cardQuery.status === 'pending' ||
        cardQuery.isPending ||
        accountQuery.status === 'pending' ||
        accountQuery.isFetching
    ) {
        return <Loader />;
    }

    if (cardQuery.isError || accountQuery.isError) {
        return <ErrorCard title={messageErrorText} />;
    }

    const card = cardQuery.data;
    const account = accountQuery.data;

    return (
        <div className="sgw-layout seven-four-container">
            <div className="sgw-layout-item seven">
                <ListPanelWrapper titleContent={<h2>{blockTitle}</h2>}>
                    <CreditCardPanelItem
                        account={account}
                        hide={!card.allowedOperations.block}
                        iconType={IconTypes.SPERR_KORT_24}
                        piwikTag={piwik.cardDetails.cardFunctionalityButtonSperrKort}
                        sitecorePath="kredittbankenBlockCard"
                        title={blockCard}
                        card={card}
                    />
                    <CreditCardPanelItem
                        account={account}
                        hide={!card.allowedOperations.unblock}
                        iconType={IconTypes.SPERR_KORT_24}
                        piwikTag={piwik.cardDetails.cardFunctionalityButtonSperrKort}
                        sitecorePath="kredittbankenUnblockCard"
                        title={unblockCard}
                        card={card}
                    />
                    <CreditCardPanelItem
                        account={account}
                        hide={!card.allowedOperations.reorder}
                        iconType={IconTypes.RESIRKULER_24}
                        piwikTag={piwik.cardDetails.cardFunctionalityButtonSperrKort}
                        sitecorePath="kredittbankenOrderCard"
                        title={reorderTitle}
                        card={card}
                    />
                </ListPanelWrapper>
            </div>
        </div>
    );
};
export default BlockReorderKb;
